/*
 *		Copyright (c) 2011-2021 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .directive('accViewInFolder', ['RoutePaths', function (RoutePaths) {
        return {
            replace: true,
            transclude: true,
            template: ' <a href ng-href="{{folderPath}}" ng-transclude></a>',
            scope: {
                node: '<'
            },
            link: function ($scope) {
                $scope.folderPath = _getFolderPath($scope.node);

                $scope.$watch('node', function () {
                    $scope.folderPath = _getFolderPath($scope.node);
                });
            }
        };

        function _getFolderPath(node) {
            var folderPath = '#' + RoutePaths.NODES;

            if (node['parent_uuid'] !== '0') {
                folderPath += '/' + node['parent_uuid'];
            }

            return folderPath + '?highlight_uuid=' + node['uuid'];
        }
    }]);
